<div class="container">
    <div class="row">
        <div class="col text-center align-items-center">
            <form name="loginForm" novalidate>
                <div class="form-horizontal text-center voffset-40">
                    <span>
                        <img src="assets/images/logo.png" width="75px" alt="Bay Club" />
                    </span>

                    <div>
                        <button type="button"  class="btn btn-success voffset-40" bcClick (clicked)="login()">
                            {{'Login.LoginBtn' | translate}}
                        </button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>